<template>
    <div
        v-show="isVisible"
        class="loading-container"
        :class="containerClassMap"
    >
        <div class="spinner"></div>
        <slot>
            <span style="color: #cccccc; font-weight: 700">Loading...</span>
        </slot>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';

    // ----- props -----
    const props = withDefaults(
        defineProps<{
            visible?: boolean;
            fullscreen?: boolean;
        }>(),
        {
            visible: false,
            fullscreen: false,
        }
    );

    // ----- computed -----
    const isVisible = computed(() => props.visible);

    const containerClassMap = computed(() => {
        return {
            fullscreen: props.fullscreen,
        };
    });
</script>

<style scoped lang="scss">
    .loading-container {
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 9999;

        &.fullscreen {
            position: fixed;
            z-index: 999999;
        }
    }

    .spinner {
        width: 40px;
        height: 40px;
        border: 4px solid #cccccc;
        border-top-color: #42b883;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
</style>
